import { getCurrentMagentoClient } from "@magento/clients/getClient";

import { useQuery } from "@jti/rest-api";

export const useBrandConsumablesQuery = (brandCode: string) => {
  return useQuery({
    queryKey: ["BRAND_CONSUMABLES", brandCode],
    queryFn: () => getCurrentMagentoClient().getBrandConsumables(brandCode),
    enabled: !!brandCode,
  });
};
